















































































/* eslint-disable */
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import ApiPlans from '@finx/web-repository/src/apis/Plans/Plans'
import { Auth } from '@finx/web-repository/src/services/Oidc'

@Component

export default class ViewPlanos extends Vue {
  activePlanWindow: any = 0
  hasDescontoMesesInsencao: Boolean = false
  isDemonstracaoPlan: Boolean = false
  isUpdatePlan: Boolean = false
  plans: Array<any> = []
  assinatura: any = ''

  get assinaturaExpired(): Boolean {
    return this.assinatura === undefined || this.assinatura === ''
  }

  data() {
    return {
      isUpdatePlan: false,
    }
  }

  mounted() {
    this.getPlans()
    this.checkAction()
    this.getAssinatura()
  }

  backToPerfil() {
    this.$router.push('/perfil')
  }

  checkAction() {
    if (this.$route.fullPath === '/plano/alterar') this.isUpdatePlan = true
  }

  disableControlButton(method: string): boolean {
    if (method === 'prev' && this.activePlanWindow === 0) return true
    if (method === 'next' && this.activePlanWindow === 2) return true

    return false
  }

  redirectUser() {
    if (this.assinaturaExpired) {
      this.logout()
    } else {
      this.$router.push('/calculadora')
    }
  }

  async getAssinatura() {
    const request = await ApiPlans.Assinatura.getAssinatura()
    const success = request.status === 200

    if (success) {
      this.assinatura = request.data
      const { tipoAssinatura } = request.data.value.tipoAssinatura

      if (tipoAssinatura === 'Demonstracao') this.isDemonstracaoPlan = true
    }
  }

  async getPlans() {
    const plans = await ApiPlans.Plans.getPlans()
    this.plans = this.orderedPlans(plans.data)

    // @ts-ignore
    this.plans.map((plan) => {
      if (plan.desconto && plan.desconto.mesesInsencao) {
        this.hasDescontoMesesInsencao = true
      }
    })
  }

  logout(): void {
    this.$router.push('/logout')
  }

  orderedPlans(list) {
    return _.orderBy(list, 'valor')
  }

  setPlanWindow(index: number, method: string): void {
    if (method == 'prev') this.activePlanWindow -= 1
    if (method == 'next') this.activePlanWindow += 1
  }
}
